import {
  Checkbox,
  Flex,
  FlexItem,
  FormElement,
  Select
} from 'mailup-web-components'
import {
  otherFiltersState,
  taskConditionsState
} from 'Pages/Task/recoil/state/task'

import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue } from 'recoil'

const ConditionsOtherFilterTrue = () => {
  const [{ OtherFilterTrue, OtherFilterTrueId }, setTaskConditionsState] =
    useRecoilState(taskConditionsState)
  const { items } = useRecoilValue(otherFiltersState)
  const intl = useIntl()
  const onChangeConditionsAnagraphicFilterTrue = () => {
    setTaskConditionsState((prev) => ({
      ...prev,
      OtherFilterTrue: !prev.OtherFilterTrue,
      isDirty: true
    }))
  }

  const onChangeOtherFilterTrueId = (val) => {
    setTaskConditionsState((prev) => ({
      ...prev,
      OtherFilterTrueId: val,
      isDirty: true
    }))
  }

  return (
    <>
      <Flex alignItems='flex-start'>
        <FlexItem margin='10px 0 0 0'>
          <Checkbox
            checked={OtherFilterTrue}
            onChange={onChangeConditionsAnagraphicFilterTrue}
            label={intl.formatMessage(
              { id: 'Load.Task.ConditionsOtherFilterTrue' },
              {
                strong: (str) => <strong>{str}</strong>
              }
            )}
            data-mu-test='checkBox-ConditionsAnagraphicFilterTrue'
          />{' '}
        </FlexItem>
        <Flex display='block' margin='0 8px' minWidth='300px'>
          <FormElement
            feedback={
              OtherFilterTrue && !OtherFilterTrueId
                ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
                : null
            }
          >
            <Select
              value={OtherFilterTrueId}
              onChange={onChangeOtherFilterTrueId}
              searchable
              placeholder={intl.formatMessage({
                id: 'Load.Task.ConditionsOtherFilterPlaceholder'
              })}
              disabled={!OtherFilterTrue}
              options={items}
              error={OtherFilterTrue && !OtherFilterTrueId ? 'danger' : null}
            />
          </FormElement>
        </Flex>
      </Flex>
    </>
  )
}

export default ConditionsOtherFilterTrue
